import { render, staticRenderFns } from "./qiyePingjia.vue?vue&type=template&id=97a616be&scoped=true&"
import script from "./qiyePingjia.vue?vue&type=script&lang=js&"
export * from "./qiyePingjia.vue?vue&type=script&lang=js&"
import style0 from "./qiyePingjia.vue?vue&type=style&index=0&id=97a616be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a616be",
  null
  
)

export default component.exports